// Capitalize the first letter of a string
export function capitalize(value) {
  if (typeof value !== 'string') return value;
  if (value.length === 0) return '';
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

// Convert snake_case to Title Case
export function toTitleCase(value) {
  if (typeof value !== 'string') return value;
  return value.replace(/_/g, ' ').replace(/\b\w/g, (match) => match.toUpperCase());
}
